import type { JSX } from "react";
import { NavLink } from "react-router";

import { ACCOUNT_TABS, USER_MEMORY_PATH } from "@/lib/navigation";
import { cn } from "@/lib/utils";

export interface AccountNavPanelProps {
  hasUnreadMemory: boolean;
  onNavigate?: () => void;
}

export function AccountNavPanel({
  hasUnreadMemory,
  onNavigate,
}: AccountNavPanelProps): JSX.Element {
  return (
    <nav aria-label="Mi cuenta" className="flex flex-col gap-0.5 px-2 py-3">
      {ACCOUNT_TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          onClick={onNavigate}
          className={({ isActive }) =>
            cn(
              "flex items-center rounded-md px-3 py-1.5 text-left text-body-3 transition-colors",
              isActive
                ? "bg-muted font-semibold text-foreground"
                : "text-muted-foreground hover:bg-muted/50 hover:text-foreground",
            )
          }
        >
          <tab.icon aria-hidden="true" className="mr-1.5 size-3.5 shrink-0" strokeWidth={1.75} />
          {tab.label}
          {tab.to === USER_MEMORY_PATH && hasUnreadMemory && (
            <span
              aria-label="memoria actualizada"
              className="ml-1.5 inline-block h-1.5 w-1.5 rounded-full bg-brand-extra-2-40 align-middle"
            />
          )}
        </NavLink>
      ))}
    </nav>
  );
}
